import { LandingTheme } from '@anm/api/modules/hosting';
import SelectionList, { ChangeHandler } from '@anm/components/list/SelectionList';
import SectionTitle from '@anm/components/video-landings/SectionTitle';
import { DEFAULT_WAVE_COLOR } from '@anm/constants/colors';
import { themeSelection } from '@anm/data/video-landings/selection';
import { FC } from 'react';

import ThemeItem from './ThemeItem';
import { ListWrapper } from './Wrapper';

type ThemeSelectionProps = ChangeHandler & {
  paidThemes?: LandingTheme[];
  isButtonIcon?: boolean;
  playerColor?: string;
  selectedThemeIndex?: number;
};

const ThemeSelection: FC<ThemeSelectionProps> = ({
  onChange,
  children,
  paidThemes,
  isButtonIcon = true,
  playerColor = DEFAULT_WAVE_COLOR,
  selectedThemeIndex = 0
}) => (
  <ListWrapper>
    <SectionTitle level={2} title="Theme" />
    {children}
    <SelectionList
      {...{ onChange }}
      list={themeSelection.map(({ name }) => ({
        name,
        key: name,
        isPaid: paidThemes?.includes(name),
        renderContent: () => (
          <ThemeItem
            {...{ name, isButtonIcon }}
            playerColor={selectedThemeIndex < 4 ? playerColor : DEFAULT_WAVE_COLOR}
          />
        )
      }))}
      itemSize="medium"
      selectedItemIndexes={[selectedThemeIndex]}
    />
  </ListWrapper>
);

export default ThemeSelection;
